/**
 * Ícones das modalidades de "Gravar corrida" (v0.19.2): uma só linguagem — grade 24×24, traço de 1,75, pontas e cantos
 * arredondados, sem preenchimento — para Corrida, Esteira, Caminhada e Fortalecimento. Corrida, Caminhada e o halter
 * seguem o desenho dos ícones "run", "walk" e "barbell" do Tabler Icons (MIT); a Esteira é própria (o Tabler não tem
 * uma), desenhada com a mesma figura, a mesma espessura e o mesmo tamanho de cabeça.
 * Sem dependência: SVG inline; o nome da modalidade vai em aria-label/title do botão, não no desenho.
 */
import type { SVGProps } from "react";

type P = SVGProps<SVGSVGElement>;

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
  focusable: false,
};

/** Corrida: figura em passada, tronco inclinado para a frente. */
export const SportRun = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="13" cy="4" r="1" />
    <path d="M4 17l5 1l.75-1.5" />
    <path d="M15 21v-4l-4-3l1-6" />
    <path d="M7 12V9l5-1l3 3l3 1" />
  </svg>
);

/** Caminhada: figura ereta, passo curto. */
export const SportWalk = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="13" cy="4" r="1" />
    <path d="M7 21l3-4" />
    <path d="M16 21l-2-4l-3-3l1-6" />
    <path d="M6 12l2-3l4-1l3 3l3 1" />
  </svg>
);

/** Esteira: a mesma figura de corrida, menor, sobre a esteira (corrimão à direita e base com rolos). */
export const SportTreadmill = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="10.5" cy="3.5" r="1" />
    <path d="M5 13.5l3.5.6l.5-1.1" />
    <path d="M13 16v-3l-3-2.3l.8-4.2" />
    <path d="M7.5 9.8V7.6l3.3-.7l2.2 2.1l2.2.7" />
    <path d="M19 17V8h-2.5" />
    <rect x="3" y="17.5" width="18" height="3.5" rx="1.75" />
  </svg>
);

/** Fortalecimento: halter com anilhas, como o "barbell" do Tabler. */
export const SportStrength = (p: P) => (
  <svg {...base} {...p}>
    <path d="M2 12h1" />
    <path d="M6 8H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2" />
    <path d="M6 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z" />
    <path d="M9 12h6" />
    <path d="M15 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1z" />
    <path d="M18 8h2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2" />
    <path d="M22 12h-1" />
  </svg>
);

/** Marca de seleção (pequena, no canto do círculo). */
export const SportCheck = (p: P) => (
  <svg {...base} strokeWidth={3} {...p}>
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
);
